export const NAME = 'USER_CLASSIFICATIONS';

export const userClassifications = (store) => store[NAME] || {};

export const userClassificationsByType = (store, classificationType) =>
  store[NAME]?.[classificationType]?.data || [];

export const isLoadingUserClassifications = (store) =>
  Object.values(store[NAME] || {}).some(({ isLoading }) => isLoading);

export default {
  userClassifications,
  userClassificationsByType,
  isLoadingUserClassifications,
};
